//#region src/Tag/Tag.type.ts
const COLORS_PRESET = {
	red: "text-additional-red-50 bg-additional-red-90",
	"red-solid": "text-additional-red-90 bg-additional-red-50",
	orange: "text-additional-orange-50 bg-additional-orange-90",
	"orange-solid": "text-additional-orange-90 bg-additional-orange-50",
	yellow: "text-additional-yellow-50 bg-additional-yellow-90",
	"yellow-solid": "text-additional-yellow-90 bg-additional-yellow-50",
	olive: "text-additional-olive-50 bg-additional-olive-90",
	"olive-solid": "text-additional-olive-90 bg-additional-olive-50",
	green: "text-additional-green-50 bg-additional-green-90",
	"green-solid": "text-additional-green-90 bg-additional-green-50",
	turquoise: "text-additional-turquoise-50 bg-additional-turquoise-90",
	"turquoise-solid": "text-additional-turquoise-90 bg-additional-turquoise-50",
	blue: "text-additional-blue-50 bg-additional-blue-90",
	"blue-solid": "text-additional-blue-90 bg-additional-blue-50",
	violet: "text-additional-violet-50 bg-additional-violet-90",
	"violet-solid": "text-additional-violet-90 bg-additional-violet-50",
	fuchsia: "text-additional-fuchsia-50 bg-additional-fuchsia-90",
	"fuchsia-solid": "text-additional-fuchsia-90 bg-additional-fuchsia-50",
	magenta: "text-additional-magenta-50 bg-additional-magenta-90",
	"magenta-solid": "text-additional-magenta-90 bg-additional-magenta-50",
	grey: "text-type-minor bg-neutrals-95",
	darkGrey: "text-type-minor bg-neutrals-80"
};
//#endregion
export { COLORS_PRESET };

//# sourceMappingURL=Tag.type.js.map